import { render, staticRenderFns } from "./ModalPerfilProfesional.vue?vue&type=template&id=0d333971&scoped=true&"
import script from "./ModalPerfilProfesional.vue?vue&type=script&lang=js&"
export * from "./ModalPerfilProfesional.vue?vue&type=script&lang=js&"
import style0 from "./ModalPerfilProfesional.vue?vue&type=style&index=0&id=0d333971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d333971",
  null
  
)

export default component.exports